import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiAlignRight, FiXCircle } from "react-icons/fi";
import { useMsal } from "@azure/msal-react";

const OracleNavBar = () => {
  const [isMenu, setisMenu] = useState(false);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let ipsLoggedInEnterpriseId = '';  
  if(activeAccount) {
    ipsLoggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;     
  }

  const allowedUsersForSAPFeedbacksData = [      
    'vanitadevi.patil',    
    'h.srinivasan',
    'madhuri.gattu',
    'raji.raghunath',
    'arun.ragul.arasan',
    'varsha.a.tyagi',
    'jeevadharani.ramanan',
    'ankur.e.mishra',  
  ];

  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push('menuq2');
  } else {
    boxClass.push('');
  }
  return (
    <div className="header__middle">
      <div className="head-container">
        <div className="header__middle__menus">
          <nav className="main-nav ">
            {isResponsiveclose === true ? (
              <>
                <span
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  <FiXCircle />
                </span>
              </>
            ) : (
              <>
                <span
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  <FiAlignRight />
                </span>
              </>
            )}
            <ul className={boxClass.join(" ")}>
              <li className="menu-item">
                <NavLink onClick={toggleClass} exact activeClassName="is-active" className="nav-links" to="/Oracle/Courses"> Courses </NavLink>
              </li>
              <li className="menu-item">
                <NavLink onClick={toggleClass} exact activeClassName="is-active" className="nav-links" to="/Oracle/LearningPaths"> Learning Paths </NavLink>
              </li>
              <li className="menu-item">
                <NavLink onClick={toggleClass} exact activeClassName="is-active" className="nav-links" to="/Oracle/Testimonials"> Testimonials </NavLink>
              </li>
              <li className="menu-item">
                <NavLink onClick={toggleClass} exact activeClassName="is-active" className="nav-links" to="/Oracle/LkmExperts"> L&TT Experts </NavLink>
              </li>
              {/* <li className="menu-item">
            <NavLink onClick={toggleClass} exact activeClassName="is-active" className="nav-links" to="/Oracle/calendar"> Calendar </NavLink>
         </li> */}
              <li className="menu-item">
                <a
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  target="_blank"
                  href="https://atci.lkm.eitacademy.accenture.com/OracleAcademy/oracle-calendar/"
                  rel="noreferrer"
                >
                  Calendar
                </a>
              </li>
              <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/Oracle/Awards"
                >                    
                  Awards
                </NavLink>
              </li>
              <li className="menu-item">
                  <NavLink
                    onClick={toggleClass}
                    activeClassName="is-active"
                    className="nav-links"
                    to="/Oracle/Feedback"
                  >                    
                    Feedback
                  </NavLink>
                </li>
                {allowedUsersForSAPFeedbacksData.includes(ipsLoggedInEnterpriseId) && 
                  <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/Oracle/Feedbacks"
                    >                      
                      Admin
                    </NavLink>
                  </li>}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  )
}

export default OracleNavBar;